<template>
  <div class="data-manage">
    <star-condition-layout
            :onSearch="handleSearch"
            :onReset="reset"
            :loading="loading"
            ref="condition"
    >
      <star-condition-cell label="标题">
        <a-input v-model="search.searchKey"></a-input>
      </star-condition-cell>
      <star-condition-cell label="采集状态">
        <a-select
                v-model="search.status"
                placeholder="请选择采集状态"
                allowClear
                style="width: 100%"
                @change="handleSearch"
        >
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option value="0"> 等待采集 </a-select-option>
          <a-select-option value="1"> 正在采集 </a-select-option>
          <a-select-option value="2"> 采集成功 </a-select-option>
          <a-select-option value="-1"> 采集失败 </a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="采集时间">
        <a-range-picker
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                @change="handleSearch"
                v-model="search.range"
                allowClear
                style="width: 250px"
        />
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-wrap"  style="margin-top: 15px;">
      <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary"  @click="handleAdd">新增</a-button>

        <a-dropdown type="primary" style="margin-left: 10px">
          <a-button type="primary">
            导入数据 <a-icon type="down" />
          </a-button>
          <a-menu slot="overlay">
            <a-menu-item key="download" style="margin-left: 10px" @click="downloadTemplate">
              下载导入模板
            </a-menu-item>
            <a-menu-item key="upload">
              <a-upload
                      style="display: inline-block"
                      name="file"
                      :customRequest="changeUploadFile"
                      :showUploadList="false"
              >
                导入数据
              </a-upload>
            </a-menu-item>
          </a-menu>
          <a-icon slot="icon" type="download" />
        </a-dropdown>

        <a-button
                style="margin-left: 10px"
                type="primary"
                :disabled="selectedRowKeys.length == 0"
                @click="handleDelete"
        >删除</a-button
        >

        <a-dropdown
                :disabled="selectedRowKeys.length == 0"
                type="primary"
                style="margin-left: 10px"
        >
          <a-button type="primary">
            下载选中数据 <a-icon type="down" />
          </a-button>
          <a-menu slot="overlay" @click="handleDownloadBatch">
            <a-menu-item key="csv"> csv 格式文件 </a-menu-item>
            <a-menu-item key="txt"> txt 文本文件 </a-menu-item>
          </a-menu>
          <a-icon slot="icon" type="download" />
        </a-dropdown>

        <a-dropdown type="primary" style="margin-left: 10px">
          <a-button type="primary">
            下全量下载数据  <a-icon type="down" />
          </a-button>
          <a-menu slot="overlay" @click="handleDownloadAll">
            <a-menu-item key="csv"> csv 格式文件 </a-menu-item>
            <a-menu-item key="txt"> txt 文本文件 </a-menu-item>
          </a-menu>
          <a-icon slot="icon" type="download" />
        </a-dropdown>

        <a-button
                style="margin-left: 10px"
                type="primary"
                :disabled="selectedRowKeys.length == 0"
                @click="handleRePullAll"
        >批量重新采集</a-button>
        <!--          <a-button style="float: right" type="primary" @click="downloadTemplate">-->
        <!--            下载导入模板-->
        <!--          </a-button>-->
      </TableHeadIcons>

      <a-table
        :loading="loading"
        :size="tableDensity"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="subjectContentId"
        :columns="showColumns"
        :dataSource="dataSource"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <span slot="subcontentTitle" slot-scope="text, record, index">
          <a-tooltip>
            <template slot="title"> {{ record.url }} </template>
            <a href="javascript:;" @click="handleInfo(record)">
              {{ record.title || '未知标题' }}
            </a>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制链接 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="record.url"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>

        <div slot="status" slot-scope="text, record">
          <span class="wait" v-if="record.status == 0">等待采集</span>
          <span class="processing" v-if="record.status == 1">正在采集</span>
          <span class="success" v-if="record.status == 2">采集成功</span>
          <span class="failure" v-if="record.status == -1">采集失败</span>
        </div>

        <div slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleInfo(record)"> <a-icon type="file" /> 采集详情 </a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="handleEdit(record)"> <a-icon type="edit" /> 修改 </a>
          <a-divider v-if="record.status == -1" type="vertical" />
          <a v-if="record.status == -1" href="javascript:;" @click="handleRePull(record)">
            <a-icon type="redo" /> 重新采集
          </a>
        </div>
      </a-table>
      <PageHelper
        @previous="handlePagePrevious"
        @next="handlePageNext"
        :preDisabled="preDisabled"
        :nextDisabled="nextDisabled"
      >
      </PageHelper>
    </div>
    <a-drawer
      title="新增列表采集"
      width="600"
      :closable="true"
      :visible="visible"
      @close="visible = false"
    >
      <Form ref="form" v-if="visible" @refresh="handleRefresh" :formModel="formModel" />
    </a-drawer>

    <ChangeSubject
      :changeVisible.sync="changeVisible"
      :subjectId="subjectId"
      :subjectContentId.sync="selectSubjectContentId"
      @success="getTableList"
    >
    </ChangeSubject>
  </div>
</template>

<script>
import {
  querySubjectContentListApi,
  deleteSubjectItemApi,
  uploadByExcelApi,
  downLoadByBatchApi,
  downLoadByBatchAll,
  addSubjectContentApi
} from '@/api/TopicCrawl/CollectList'

import Form from './Form.vue'
import PageHelper from '@/components/PageHelper/'
import moment from 'moment'
import { getFileUrlApi } from '@/api/Common/File'
import ChangeSubject from './ChangeSubject.vue'
export default {
  data() {
    return {
      loading: false,
      uploadLoading: false,
      visible: false,
      search: {
        type: 'content',
        range: [],
        status: undefined,
        searchKey: ''
      },
      tableDensity: 'middle',
      columns: [
        {
          title: '标题',
          show: true,
          ellipsis: true,
          dataIndex: 'title',
          key: 'title',
          scopedSlots: { customRender: 'subcontentTitle' }
        },
        {
          title: '采集状态',
          show: true,
          scopedSlots: { customRender: 'status' },
          width: 110
        },
        {
          title: '开始采集时间',
          show: true,
          ellipsis: true,
          dataIndex: 'startTime',
          width: 160
        },
        {
          title: '采集结束时间',
          show: true,
          ellipsis: true,
          dataIndex: 'endTime',
          width: 160
        },
        {
          title: '操作',
          width: 270,
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true
      },
      sorter: {},
      formModel: null,
      selectedRowKeys: [],
      action: '',
      globalQuery: null,
      currentPage: 1,
      currentPageSize: 10,
      preDisabled: true,
      nextDisabled: false,
      changeVisible: false,
      subjectId: null,
      selectSubjectContentId: null,
      deleteModal: null
    }
  },
  created() {
    this.getTableList()
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  methods: {
    reset() {
      this.search.range = []
      this.search.status = undefined
      this.search.searchKey = undefined
      this.getTableList()
    },
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('链接已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('链接复制失败')
    },

    async handleRePullAll() {
      let list = this.dataSource.filter((item) => {
        return this.selectedRowKeys.includes(item.subjectContentId)
      })
      let urls = list.map((item) => item.url)
      let posts = urls.map((url) => {
        return {
          url,
          type: 'content'
        }
      })
      let { subjectId } = this.$route.query
      const res = await addSubjectContentApi({ subjectId, subjectContentId: '' }, posts)
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.selectedRowKeys = []
        this.getTableList()
      } else {
        this.$message.error(msg)
      }
    },

    async handleRePull({ url }) {
      let { subjectId } = this.$route.query
      const res = await addSubjectContentApi({ subjectId, subjectContentId: '' }, [
        { url, type: 'content' }
      ])
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.getTableList()
      } else {
        this.$message.error(msg)
      }
    },

    async getTableList() {
      let { subjectId } = this.$route.query
      this.subjectId = parseInt(subjectId)
      let query = {
        pn: this.currentPage,
        pageSize: this.currentPageSize,
        subjectId,
        type: this.search.type,
        status: this.search.status,
        searchKey: this.search.searchKey
      }
      if (this.search.range.length > 0) {
        query.startTime = moment(this.search.range[0]).format('YYYY-MM-DD HH:mm:ss')
        query.endTime = moment(this.search.range[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      this.loading = true
      this.globalQuery = query
      let res = await querySubjectContentListApi(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == '200') {
        this.dataSource = data || []

        if (this.dataSource.length < this.currentPageSize) {
          this.nextDisabled = true
        } else {
          this.nextDisabled = false
        }

        if (this.currentPage > 1) {
          this.preDisabled = false
        } else {
          this.preDisabled = true
        }
      } else {
        this.$message.error(msg)
      }
    },
    handleAdd() {
      this.formModel = null
      this.visible = true
    },

    handleEdit(record) {
      this.changeVisible = true
      this.selectSubjectContentId = record.subjectContentId
    },
    handleInfo({ subjectContentId }) {
      this.$router.push({
        name: 'wikipedia_info',
        query: { subjectContentId, type: 'content' }
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.getTableList()
    },

    handleRefresh() {
      this.currentPage = 1
      this.visible = false
      this.getTableList()
    },

    handleReset() {
      this.search.range = []
      this.search.status = undefined
      this.search.searchKey = ''
      this.handleSearch()
    },

    //批量下载
    async handleDownloadBatch(val) {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请选择要下载数据项!')
        return
      }
      let { key } = val
      let query = {
        type: this.search.type,
        downType: key,
        subjectId: this.subjectId
      }
      let ids = this.selectedRowKeys
      let res = await downLoadByBatchApi(query, ids)
      this.download('站点批量导出数据-' + new Date().getTime(), key, res)
    },

    async changeUploadFile(info) {
      this.uploadLoading = true
      let fileData = new FormData()
      fileData.append('file', info.file)
      let res = await uploadByExcelApi(
        { subjectId: this.$route.query.subjectId, type: this.search.type },
        fileData
      )
      this.uploadLoading = false
      const { extra, code, msg } = res
      if (code == '200') {
        this.$message.success('导入成功成功')
        this.currentPage = 1
        this.getTableList()
      } else {
        this.$message.error('导入失败:' + msg)
      }
    },
    //全量下载
    async handleDownloadAll(val) {
      let { key } = val
      this.globalQuery.downType = key
      this.globalQuery.type = this.search.type
      let res = await downLoadByBatchAll(this.globalQuery)
      this.download('站点全量导出数据-' + new Date().getTime(), key, res)
    },

    async downloadTemplate() {
      let res = await getFileUrlApi({ fileName: 'baike_upload' })
      const { extra, code, msg } = res
      if (code == '200') {
        if (extra.downloadUrl != null && extra.downloadUrl != '') {
          window.location.href = extra.downloadUrl
        } else {
          this.$message.error('文件下载失败')
        }
      } else {
        this.$message.error('文件下载失败')
      }
    },
    //处理流下载
    download(fileName, key, data) {
      const blob = new Blob([data])
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = fileName + '.' + (key == 'excel' ? 'xls' : key == 'csv' ? 'csv' : 'txt')
      a.href = blobUrl
      a.click()
    },

    handleUploadChange(info) {
      if (info.file.status !== 'uploading') {
        this.uploadLoading = true
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 导入成功`)
        this.uploadLoading = false
        this.getTableList()
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 导入失败`)
        this.uploadLoading = false
      }
    },

    handleDelete() {
      let that = this
      this.deleteModal = this.$confirm({
        title: '警告',
        content: '是否确认删除数据？',
        onOk() {
          return new Promise((resolve, reject) => {
            that.deleteSubjectContents()
          })
        },
        onCancel() {}
      })
    },
    async deleteSubjectContents() {
      let { subjectId } = this.$route.query
      const res = await deleteSubjectItemApi({ subjectId }, this.selectedRowKeys)
      this.deleteModal.destroy()
      const { code, msg } = res
      if (code == '200') {
        this.selectedRowKeys = []
        this.getTableList()
        this.$message.success('删除成功')
      } else {
        this.$message.error('删除失败')
      }
      return true
    },
    // //根据id删除数据
    // async handleDelete() {
    //   let { subjectId } = this.$route.query
    //   const res = await deleteSubjectItemApi({ subjectId }, this.selectedRowKeys)
    //   const { code, msg } = res
    //   if (code == '200') {
    //     this.selectedRowKeys = []
    //     this.getTableList()
    //     this.$message.success(msg)
    //   } else {
    //     this.$message.error(msg)
    //   }
    // },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination
      if (sorter.order) {
        this.sorter = {
          orderKey: sorter.field,
          isAsc: sorter.order == 'ascend' ? true : false
        }
      } else {
        this.sorter = {}
      }
      this.getTableList()
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handlePagePrevious() {
      this.currentPage--
      this.currentPage = this.currentPage > 0 ? this.currentPage : 1
      this.getTableList()
    },
    handlePageNext() {
      this.currentPage++
      this.getTableList()
    }
  },
  components: {
    Form,
    PageHelper,
    ChangeSubject
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  .search {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 10px;
  }
  .table-wrap {
    background: #fff;
    padding: 0px 20px 0 20px;
  }
}
span {
  border-radius: 4px;
  padding: 4px 8px;

  &.success {
    background: #f0faef;
    border: 0.1px solid #66c25d;
    border-radius: 4px;
  }
  &.wait {
    background: #f0f2f5;
    border: 1px solid #b5bbc3;
    border-radius: 4px;
  }
  &.failure {
    background: #fff6e2;
    border: 0.5px solid #ffc852;
    border-radius: 4px;
  }
  &.processing {
    background: #f0f7ff;
    border: 1px solid #3c93ff;
    border-radius: 4px;
  }
}
</style>
